import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import CarForm from '../../components/Entity/Cars/Update/CarForm';
 
const FinanceAdd = () => { 
  return <Layout > 
       <CarForm id={0} isAdd={true}></CarForm>  
  </Layout>;
}

export default FinanceAdd;